<h1>{{ "Dashboard" | translate }}</h1>